import {
  EMPTY_STRING,
  MIN_ORG_NAME_LENGTH,
  SUSPICIOUS_NAME_TOKENS
} from "src/components/constant/constant";

export const userNameValidation = (input: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!input) {
    return "Username is required";
  }

  if (emailRegex.test(input)) {
    return "The username cannot be an email address.";
  } else {
    return EMPTY_STRING;
  }
};

export const emailValidation = (input: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  return emailRegex.test(input);
};

export const isUUID = (str: string) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  return uuidRegex.test(str);
};

export const hasHTML = (str: string) => {
  const htmlRegex = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>|<([A-Za-z][A-Za-z0-9]*)\b[^>]*\/>/;

  return htmlRegex.test(str);
};

const suspiciousTokenRegex = new RegExp(`\\b(?:${SUSPICIOUS_NAME_TOKENS.join("|")})\\b`, "gi");

export const sanitizeName = (name?: string | null): string => {
  if (!name) return EMPTY_STRING;

  return name.replace(suspiciousTokenRegex, EMPTY_STRING).replace(/\s+/g, " ").trim();
};

export const isValidOrgName = (name?: string | null, minLength: number = MIN_ORG_NAME_LENGTH): boolean => {
  const sanitized = sanitizeName(name);

  if (!sanitized || sanitized.length < minLength) return false;

  const lower = sanitized.toLowerCase();

  if (SUSPICIOUS_NAME_TOKENS.some((token) => token === lower)) return false;
  if (suspiciousTokenRegex.test(sanitized)) {
    suspiciousTokenRegex.lastIndex = 0;
    return false;
  }
  suspiciousTokenRegex.lastIndex = 0;
  return true;
};

// Mirrors the Cognito pool password policy (both CPC pools: 12+ chars, upper,
// lower, number, symbol) and the rules PasswordPolicyTooltip lists. Checking it
// before confirmResetPassword keeps a weak password from ever reaching Cognito:
// a rejected confirm used to be read as an expired code, which threw away the
// emailed link's code and left the user at a code box with nothing to type.
export const MIN_PASSWORD_LENGTH = 12;

export const passwordPolicyError = (password: string): string => {
  if (password.length < MIN_PASSWORD_LENGTH) return `Password must be at least ${MIN_PASSWORD_LENGTH} characters long`;
  if (!/[A-Z]/.test(password)) return "Password must contain an uppercase letter (A-Z)";
  if (!/[a-z]/.test(password)) return "Password must contain a lowercase letter (a-z)";
  if (!/[0-9]/.test(password)) return "Password must contain a number (0-9)";
  if (!/[^A-Za-z0-9\s]/.test(password)) return "Password must contain a special character (e.g. !@#$%_)";

  return EMPTY_STRING;
};
